export default (req) => ({
  ManagementPlatforms: () => req.get("/common/management/GetAllPlatforms"),
  ManagementOS: () => req.get("/common/management/OperatingSystems"),
  getAllPlatforms: () => req.get("/common/GetAllPlatforms"),
  getManagementPlatforms: () => req.get("/common/management/GetAllPlatforms"),
  getManagementStores: () => req.get("/common/management/GetAllStores"),
});
